import React from "react";
import { Link } from "react-router-dom";

const AdvertisingAgent = (props) => {
  return (
    <section
      id="id_ico_about_section"
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <h4 className="title_text text-dark mb-3">TopCoin UK Agent Programme</h4>
            <p className="text-dark fw-semibold opacity-75 mb-4">
              <strong>Help Expand the TopCoin UK Network</strong>
            </p>

            <p className="text-dark opacity-75 mb-2">
              TopCoin UK Agents help grow the TopCoin UK platform by introducing new customers and participating businesses to the TopCoin UK loyalty ecosystem.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Participation as a TopCoin UK Agent is free and available to eligible TopCoin UK members, subject to approval and the applicable programme terms.
            </p>
            <p className="text-dark opacity-75 mb-4">
              TopCoin UK operates as a technology-driven loyalty and promotional platform designed to connect customers, businesses and authorised Agents through a structured participation network.
            </p>

            <h5 className="title_text text-dark">1. The TopCoin UK Ecosystem</h5>
            <p className="text-dark opacity-75 mb-2">
              The TopCoin UK ecosystem is a digital loyalty network connecting customers, participating businesses and authorised Agents through the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Customers participate in the platform primarily through shopping with participating businesses.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Agents have a separate role. They help expand the TopCoin UK network by introducing new customers or businesses to the platform.
            </p>
            <p className="text-dark opacity-75 mb-4">
              <strong>Customers do not receive Agent rewards or Agent recognition simply for referring other customers. Referrals under the Agent Programme are an Agent activity.</strong>
            </p>

            <h5 className="title_text text-dark">2. Become a TopCoin UK Agent</h5>
            <p className="text-dark opacity-75 mb-2">
              Eligible TopCoin UK members can apply to become an Agent and participate in the expansion of the TopCoin UK network.
            </p>
            <p className="text-dark opacity-75 mb-2">
              <strong>Advertising Agents</strong> introduce new customers to TopCoin UK.
            </p>
            <p className="text-dark opacity-75 mb-2">
              <strong>Retail Agents</strong> introduce shops, retailers and other eligible businesses to TopCoin UK.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Agent participation is subject to approval and the applicable TopCoin UK Agent Programme rules.
            </p>

            <h5 className="title_text text-dark">3. Advertising Agents</h5>
            <p className="text-dark opacity-75 mb-2">
              Advertising Agents help expand the TopCoin UK customer network.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Once approved, an Advertising Agent can use their authorised Agent referral link or other approved platform tools to introduce new customers to TopCoin UK.
            </p>
            <p className="text-dark opacity-75 mb-4">
              The Advertising Agent's role is to promote the platform, introduce genuine new customers and support the growth of the TopCoin UK community.
            </p>

            <h5 className="title_text text-dark">4. Retail Agents</h5>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents help expand the network of businesses participating on the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Once approved, a Retail Agent can introduce eligible shops, retailers and other businesses that may wish to participate in the TopCoin UK loyalty and promotional ecosystem.
            </p>
            <p className="text-dark opacity-75 mb-4">
              The Retail Agent's role is to help build a wider network of participating businesses for TopCoin UK customers.
            </p>

            <h5 className="title_text text-dark">5. Referrals Are for Approved Agents</h5>
            <p className="text-dark opacity-75 mb-2">
              Joining TopCoin UK as a customer does not automatically make someone an Agent.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Customers who want to participate in the official TopCoin UK referral programme must first apply for and be approved for the appropriate Agent role.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Once approved, <strong>Advertising Agents</strong> may refer new customers and <strong>Retail Agents</strong> may introduce eligible businesses.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Customers do not earn TopCoin or Agent rewards simply by referring other customers outside the approved Agent Programme.
            </p>

            <h5 className="title_text text-dark">6. Genuine Platform Growth</h5>
            <p className="text-dark opacity-75 mb-2">
              The TopCoin UK Agent Programme is designed to support genuine growth of the platform.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Agents should introduce customers and businesses that have a genuine interest in participating in the TopCoin UK ecosystem.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Agent participation must comply with TopCoin UK programme rules, policies and applicable terms and conditions.
            </p>

            <h5 className="title_text text-dark">7. Agent Recognition and Rewards</h5>
            <p className="text-dark opacity-75 mb-2">
              Approved Agents may become eligible for Agent recognition and rewards in accordance with the rules applicable to their Agent category.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Agent recognition is separate from ordinary customer TopCoin, customer Bonus TopCoin and customer reward wallets.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Eligibility, calculation methods, milestones, settlement requirements and other conditions relating to Agent rewards are governed by the applicable TopCoin UK Agent Programme terms.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Participation as an Agent does not guarantee any particular level of rewards or income.
            </p>

            <h5 className="title_text text-dark">8. Agent Recognition Settlement</h5>
            <p className="text-dark opacity-75 mb-2">
              Where an Agent becomes eligible for a reward or settlement under the applicable Agent Programme rules, the Agent may request settlement in accordance with TopCoin UK procedures.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Settlement requests may be subject to identity and eligibility verification; applicable minimum or maximum limits; compliance and fraud-prevention checks; processing times and available settlement methods; and the applicable TopCoin UK terms and conditions.
            </p>
            <p className="text-dark opacity-75 mb-2">
              TopCoin UK Ltd may review, approve, restrict or decline settlement requests where permitted under the applicable programme terms and policies.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Agents are responsible for determining and meeting any tax obligations that may arise from rewards they receive.
            </p>

            <h5 className="title_text text-dark">9. How the Agent Programme Works</h5>
            <ul className="text-dark opacity-75 mb-4">
              <li className="mb-2"><strong>Step 1 - Join TopCoin UK:</strong> Create your TopCoin UK customer account.</li>
              <li className="mb-2"><strong>Step 2 - Apply to Become an Agent:</strong> Choose the appropriate Agent category and submit your application.</li>
              <li className="mb-2"><strong>Step 3 - Receive Approval:</strong> Once approved, your Agent account and authorised referral facilities can be activated.</li>
              <li className="mb-2"><strong>Step 4 - Start Referring:</strong> Advertising Agents can introduce new customers, while Retail Agents can introduce eligible businesses to the TopCoin UK platform.</li>
              <li className="mb-2"><strong>Step 5 - Start Earning:</strong> Approved Agents may become eligible for Agent rewards when the customers or businesses they introduce generate qualifying activity on the TopCoin UK platform, subject to the applicable Agent Programme rules.</li>
              <li className="mb-2"><strong>Step 6 - Grow Your Network:</strong> Continue introducing genuine customers or businesses and help expand the TopCoin UK platform network.</li>
              <li className="mb-2"><strong>Step 7 - Receive Eligible Agent Rewards:</strong> Where the applicable requirements and milestones are met, eligible Agent rewards may be recorded and made available in accordance with the relevant Agent Programme terms.</li>
            </ul>

            <h5 className="title_text text-dark">10. No Guaranteed Earnings</h5>
            <p className="text-dark opacity-75 mb-2">
              Participation in the TopCoin UK Agent Programme does not guarantee income, profits, rewards or financial returns.
            </p>
            <p className="text-dark opacity-75 mb-2">
              The amount of any Agent reward may depend on qualifying platform activity and the applicable Agent Programme rules.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Agents should not represent TopCoin UK Agent participation as guaranteed employment, guaranteed income or an investment opportunity.
            </p>

            <h5 className="title_text text-dark">11. Important Programme Notice</h5>
            <p className="text-dark opacity-75 mb-2">
              TopCoin UK is a loyalty and promotional platform.
            </p>
            <p className="text-dark opacity-75 mb-2">
              TopCoin is not an investment, security or ownership interest in TopCoin UK Ltd and does not earn interest.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Agent rewards, where applicable, arise from participation in the Agent Programme under its terms and should not be presented as investment returns.
            </p>

            <h5 className="title_text text-dark">12. Platform Authority</h5>
            <p className="text-dark opacity-75 mb-2">
              The TopCoin UK platform, technology, systems, branding, loyalty mechanisms and operational rules remain under the ownership and control of TopCoin UK Ltd.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Participation as an Advertising Agent or Retail Agent does not provide ownership rights in TopCoin UK Ltd, the TopCoin UK platform or its customer and business networks.
            </p>
            <p className="text-dark opacity-75 mb-4">
              TopCoin UK Ltd may review and update Agent Programme rules, eligibility requirements and reward structures in accordance with its terms and applicable law.
            </p>

            <h5 className="title_text text-dark">13. Grow With TopCoin UK</h5>
            <p className="text-dark opacity-75 mb-2">
              Advertising Agents grow the customer network.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents grow the participating business network.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Together, TopCoin UK Agents help connect more customers with more businesses and support the continued expansion of the TopCoin UK ecosystem.
            </p>

            {/* CALL TO ACTION CARD */}
            <div className="d-flex justify-content-center my-5">
              <div
                className="card shadow-sm border-0"
                style={{ maxWidth: "1000px", width: "100%", backgroundColor: "#f9f9f9" }}
              >
                <div className="card-body text-center p-5">
                  <h5
                    className="mt-2 mb-3 text-black fw-bold"
                    data-aos="fade-up"
                    data-aos-duration="800"
                   
                    
                  >
                    Become a TopCoin UK Agent
                  </h5>

                  <p
                    className="card-text mb-4 ps-3 pe-3 text-dark fw-bold"
                    data-aos="fade-up"
                    data-aos-duration="800"
                  >
                    JOIN &gt; APPLY &gt; GET APPROVED &gt; REFER &gt; START EARNING &gt; GROW
                  </p>

                  <p
                    className="card-text mb-4 ps-3 pe-3 opacity-75 text-dark"
                    data-aos="fade-up"
                    data-aos-duration="800"
                  >
                    <strong>Important:</strong> Agent rewards are linked to qualifying activity and the applicable Agent Programme rules. They are not earned merely because another person joins the platform.
                  </p>

                  <div className="mt-4 mb-2">
                    <Link className="ico_creative_btn" to="/sign_up">
                      <span className="btn_wrapper px-5 py-0">
                        <span className="btn_label text">Join Now</span>
                        <span className="btn_icon_right">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            fill="currentColor"
                          >
                            <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"></path>
                          </svg>
                        </span>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvertisingAgent;
